//var base = require('./publicapp-code');

//Vue.component('spark-publicapp', {
//    mixins: [base]
//});
